import {explodeParamsString, implodeParamsObject} from 'Utils/urlUtils';
import KeyUtils from 'Utils/keyUtils';

const DEFAULT_AXA_AGENCY_URL = 'https://agence.axa.fr';

export default class StoreLocator {
    constructor(domElement) {
        const isInitialized = domElement.dataset.storeLocatorInitialized === 'true';
        if(isInitialized) {
            return;
        }

        this.domElement = domElement;

        this.domElement.dataset.storeLocatorInitialized = 'true';
        this.filters = this.domElement.dataset.filtres_store;
        this.actions = this.domElement.dataset.actions_store;

        this.registerEvents();
    }

    registerEvents() {
        this.domElement.querySelector('.js-button-store-locator')
            .addEventListener('click', this.handleButtonClick.bind(this));
        this.domElement.querySelector('.js-input-postal')
            .addEventListener('keyup', this.handleInputKeyUp.bind(this));
    }

    handleButtonClick() {
        this.redirectUrl(this.paramUrlSetter());
    }

    handleInputKeyUp(event) {
        if(KeyUtils.isEnter(event.keyCode)) {
            this.redirectUrl(this.paramUrlSetter());
        }
    }

    // eslint-disable-next-line class-methods-use-this
    redirectUrl(url) {
        window.location.assign(url);
    }

    paramUrlSetter() {
        const geoSearch = this.domElement.querySelector('.js-input-postal');
        const geoSearchValue = geoSearch.value
            ? geoSearch.value.split(' ')
                .join('+')
            : null;

        let urlParameters = {};
        if(geoSearchValue) {
            urlParameters.geosearch = geoSearchValue;
        }

        if(this.filters) {
            urlParameters = {...urlParameters, ...explodeParamsString(this.filters)};
        }

        return `${this.actions || DEFAULT_AXA_AGENCY_URL}${implodeParamsObject(urlParameters)}`;
    }
}
